
export class RingL3RD {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Ring L3RD";
    this.scene = "Ring L3RD";
    this.data = [];
    this.page = 103;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = (options?.player?.first_name.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = (options?.player?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "10401";
      }).value = "AGE " + (options?.player?.age || "");      

      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value = "FIGHTS " + (parseInt(options?.player?.wins) + parseInt(options?.player?.losses) + parseInt(options?.player?.draws));

      xml.payload.field.find((item) => {
        return item.attr.name === "201";
      }).value = "WON " + (options?.player?.wins || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "202";
      }).value = "KOs " + (options?.player?.knockouts || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "203";
      }).value = "LOST " + (options?.player?.losses || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "204";
      }).value = "DRAWN " + (options?.player?.draws || "");



      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
